import { useQuery } from "@tanstack/react-query";
import ehjzleeInstance from "./ehjzleeInstance";

export const useCities = () => {
  const q = useQuery({
    queryKey: ["cities"],
    queryFn: async () => {
      try {
        const res = await ehjzleeInstance.get("cities");
        return (
          (res.data.cities as {
            id: string;
            name: string;
            arabicName: string;
          }[]) || []
        );
      } catch (error) {
        console.log(error);
      }
    },
  });
  return q;
};
